import { ImageCDNPath } from "GlobalConstant/";
import ImageSizes from "GlobalConstant/ImageSizes";

export const INSURANCE_HOME_ENDPOINT = "/insurance/";
export const LEAD_DATA_ENDPOINT = "/api/lead/";
export const CAR_DETAILS_BY_VERSIONID_ENDPOINT =
  "/api/CarVersionsData/GetCarDetailsByVersionId/";
export const DEFAULT_INSURANCE_BANNER_STYLES = {
  backgroundColor: "white",
  imageUrl: `${ImageCDNPath}${ImageSizes._0By0}/cw/static/landing-banners/m/m-insurance-banner.jpg`,
  horizontalPosition: "center",
  verticalPosition: "top",
  height: "130px",
};
export const HOME_AD_SLOT_PROPERTIES = {
  id: "div-gpt-ad-1435297201507-0",
  path: "/1017752/CarWale_Mobile_ROS_300x250",
  size: [[300, 250]],
};
export const SEO_TAGS = {
  TITLE: "Buy or renew car insurance policy in India",
  DESCRIPTION:
    "Buy or renew your car insurance policy. Get insurance premium quotes from CarWale. Calculate auto insurance premium in India.",
  CANONICAL: `${CW_HOST_URL}${INSURANCE_HOME_ENDPOINT}`,
};
